module.exports = __webpack_public_path__ + "assets/4af2351983cabc84d0041f2b0f1eae81.mp3";